/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Error_InitializingInputs */

const en_backend_session_error_initializing = /** @type {(inputs: Backend_Session_Error_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service is initializing, please retry in a few minutes.`)
};

const fr_backend_session_error_initializing = /** @type {(inputs: Backend_Session_Error_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service en cours d'initialisation, retentez dans quelques minutes.`)
};

const ms_sg2_backend_session_error_initializing = /** @type {(inputs: Backend_Session_Error_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkhidmatan sedang dimulakan, sila cuba semula dalam beberapa minit.`)
};

/**
* | output |
* | --- |
* | "Service is initializing, please retry in a few minutes." |
*
* @param {Backend_Session_Error_InitializingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_initializing = /** @type {((inputs?: Backend_Session_Error_InitializingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_InitializingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_initializing(inputs)
	if (locale === "fr") return fr_backend_session_error_initializing(inputs)
	return ms_sg2_backend_session_error_initializing(inputs)
});